<template>
  <div class="renderPage reporte-container animate-fade-in">
    <!-- Main Toolbar -->
    <v-toolbar color="primary" dark flat class="mb-6 rounded-xl" height="64">
      <v-icon class="mr-3" size="28">mdi-key</v-icon>
      <v-toolbar-title class="text-subtitle-1 text-sm-h6 font-weight-black px-0 text-uppercase letter-spacing-1">
        Mantenimiento de Licencias
      </v-toolbar-title>
      <v-spacer />
      <v-btn color="white" outlined class="rounded-pill font-weight-bold mr-2 d-none d-sm-flex" @click="openDialog()">
        <v-icon left>mdi-plus</v-icon> Nueva Licencia
      </v-btn>
      <v-btn icon color="white" class="d-sm-none mr-1" @click="openDialog()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn icon color="white" to="/home" class="glass-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid class="pa-0">
      <v-card class="glass-card mb-6 rounded-xl overflow-hidden" elevation="0">
        <div class="px-6 py-4 border-bottom header-glass">
          <div class="d-flex align-center flex-wrap">
            <v-icon color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
            <span class="text-subtitle-1 font-weight-bold primary--text">Listado de Licencias</span>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar Cliente"
              single-line
              hide-details
              class="modern-input mt-4 mt-sm-0"
              outlined
              dense
              rounded
              style="max-width: 300px; width: 100%;"
            ></v-text-field>
          </div>
        </div>

        <v-card-text class="pa-6">
            <v-data-table
              :headers="headers"
              :items="licencias"
              :search="search"
              :custom-filter="filterLicencias"
              :loading="loading"
              loading-text="Cargando licencias..."
              class="premium-table"
              :footer-props="{
                'items-per-page-options': [10, 20, 50, -1],
                'items-per-page-text': 'Registros por página'
              }"
            >
              <template v-slot:[`item.ciaNombre`]="{ item }">
                {{ getCiaNombre(item.cia) }}
              </template>
              <template v-slot:[`item.fechaInicio`]="{ item }">
                {{ formatDate(item.fechaInicio) }}
              </template>
              <template v-slot:[`item.fechaFin`]="{ item }">
                {{ formatDate(item.fechaFin) }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon color="primary" class="mx-1 glass-btn" @click="editItem(item)">
                    <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Dialog for Add/Edit -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card class="theme-aware-dialog rounded-xl" elevation="0">
        <v-toolbar color="primary" dark flat height="56">
            <v-icon class="mr-2">mdi-key-variant</v-icon>
            <v-toolbar-title class="text-subtitle-1 font-weight-bold">{{ formTitle }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-6">
          <v-container class="pa-0">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="editedItem.cia"
                  :items="bancas"
                  item-text="nombre"
                  item-value="companyId"
                  label="Seleccionar Banca"
                  :disabled="editedIndex > -1"
                  class="modern-input"
                  outlined
                  dense
                  rounded
                  hide-details="auto"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.fechaInicio"
                      label="Fecha de Inicio"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="modern-input"
                      outlined
                      dense
                      rounded
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.fechaInicio"
                    @input="menu1 = false"
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.fechaFin"
                      label="Fecha de Vencimiento"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="modern-input"
                      outlined
                      dense
                      rounded
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.fechaFin"
                    @input="menu2 = false"
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text class="rounded-pill px-6" @click="close()">Cancelar</v-btn>
          <v-btn color="primary" class="rounded-pill px-6 font-weight-bold shadow-soft" @click="save()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar :text="snackText" :snackbar.sync="snackValue" />
  </div>
</template>

<script>
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";

export default {
  name: "Licencias",
  components: {
    Snackbar,
  },
  data() {
    return {
      search: "",
      loading: false,
      licencias: [],
      bancas: [],
      dialog: false,
      menu1: false,
      menu2: false,
      headers: [
        { text: "Cia ID", value: "cia" },
        { text: "Banca", value: "ciaNombre" },
        { text: "Inicio", value: "fechaInicio" },
        { text: "Vencimiento", value: "fechaFin" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        cia: "",
        fechaInicio: new Date().toISOString().substr(0, 10),
        fechaFin: new Date().toISOString().substr(0, 10),
      },
      defaultItem: {
        cia: "",
        fechaInicio: new Date().toISOString().substr(0, 10),
        fechaFin: new Date().toISOString().substr(0, 10),
      },
      snackText: "",
      snackValue: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Licencia" : "Editar Licencia";
    },
  },
  created() {
    this.getData();
    this.getBancas();
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        const response = await axios.get("api/Tiempos/GetLicencias");
        this.licencias = response.data;
      } catch (error) {
        console.error("Error fetching licencias:", error);
      } finally {
        this.loading = false;
      }
    },
    async getBancas() {
      try {
        const response = await axios.get("api/Tiempos/getBancas");
        this.bancas = response.data;
      } catch (error) {
        console.error("Error fetching bancas:", error);
      }
    },
    getCiaNombre(ciaId) {
      const banca = this.bancas.find((b) => b.companyId === ciaId);
      return banca ? banca.nombre : ciaId;
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString();
    },
    filterLicencias(value, search, item) {
      if (!search) return true;
      const searchLower = search.toString().toLowerCase();
      
      const ciaId = item.cia != null ? item.cia.toString().toLowerCase() : '';
      const bancaName = this.getCiaNombre(item.cia).toLowerCase();
      const startDate = this.formatDate(item.fechaInicio).toLowerCase();
      const endDate = this.formatDate(item.fechaFin).toLowerCase();

      return ciaId.includes(searchLower) || 
             bancaName.includes(searchLower) || 
             startDate.includes(searchLower) || 
             endDate.includes(searchLower);
    },
    openDialog() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.licencias.indexOf(item);
      this.editedItem = Object.assign({}, item);
      
      // Suggest 1 month more if expiring today
      const today = new Date().toISOString().substr(0, 10);
      const expiry = new Date(item.fechaFin).toISOString().substr(0, 10);
      
      if (expiry === today) {
        const nextMonth = new Date(item.fechaFin);
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        this.editedItem.fechaFin = nextMonth.toISOString().substr(0, 10);
      } else {
          // ensure dates are strings for date picker
          this.editedItem.fechaInicio = new Date(item.fechaInicio).toISOString().substr(0, 10);
          this.editedItem.fechaFin = new Date(item.fechaFin).toISOString().substr(0, 10);
      }
      
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      try {
        if (this.editedIndex > -1) {
          await axios.post("api/Tiempos/UpdateLicencia", this.editedItem);
          this.snackText = "Licencia actualizada correctamente";
        } else {
          await axios.post("api/Tiempos/InsertLicencia", this.editedItem);
          this.snackText = "Licencia creada correctamente";
        }
        this.snackValue = true;
        this.getData();
        this.close();
      } catch (error) {
        console.error("Error saving licencia:", error);
        this.snackText = "Error al guardar la licencia";
        this.snackValue = true;
      }
    },
  },
};
</script>

<style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

.header-glass {
    background: rgba(25, 118, 210, 0.03);
}

.theme--dark .header-glass {
    background: rgba(255, 255, 255, 0.02);
}

.border-bottom {
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.theme--dark .border-bottom {
    border-bottom: 1px solid rgba(255,255,255,0.05);
}

/* Modern Inputs */
.modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(255, 255, 255, 0.5) !important;
    backdrop-filter: blur(4px);
}

.theme--dark .modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(0, 0, 0, 0.2) !important;
}

/* Table Styling */
.premium-table {
    background: transparent !important;
}

.premium-table >>> th {
    background: rgba(0, 0, 0, 0.02) !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.75rem !important;
}

.theme--dark .premium-table >>> th {
    background: rgba(255, 255, 255, 0.05) !important;
}

.premium-table >>> tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

/* Text Utilities */
.letter-spacing-1 {
    letter-spacing: 1px;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

.shadow-soft {
    box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Theme Aware Dialog */
.theme-aware-dialog {
    border-radius: 24px !important;
}
</style>
